import config, { SESSION_STORAGE_KEY_MAP, sobotChannelId } from "./constant";
import { labelMap } from "./constant";
import cookie from "js-cookie";
import { logOperation } from "./operationLogUtils";
import { encrypt } from "./crypto";
const { LOGIN_CLIENT_ID } = config;

console.log('config in common', config);

export const isWechatMiniProgramEnv = () => {
  return (window as any).__wxjs_environment === "miniprogram";
};

export function getCurrentLoginClientId() {
  return isWechatMiniProgramEnv() ? config.LOGIN_CLIENT_ID_NEW : config.LOGIN_CLIENT_ID;
}

export function getUsersLoginRedirectUrl(defaultRedirectUrl: string) {
  if (isWechatMiniProgramEnv()) {
    return config.ssoCallbackUrl;
  }
  return defaultRedirectUrl;
}

export function getLoginURL(cidLocHelper: string) {
  let location = "";
  if (window.location.host === "localhost:3000") {
    location = config.APPLICATION_ENDPOINT;
  } else {
    location = `https://${window.location.host}`;
  }
  const backPath = window.location.pathname;
  const search = window.location.search;
  search && localStorage.setItem("search", search);
  console.log("search", search);
  return `${config.LOGIN_API_ENDPOINT}?response_type=code&client_id=${getCurrentLoginClientId()}&redirect_uri=${getUsersLoginRedirectUrl(location)}&scope=openid%20profile%20email%20username&cid=${config.CID_LOGIN_CN}login=${cidLocHelper}&state=${backPath}`;
}

export function getLocation() {
  let location = "";
  if (window.location.host === "localhost:3000") {
    location = config.APPLICATION_ENDPOINT;
  } else {
    location = `https://${window.location.host}`;
  }
  return location;
}

export const dateParser = (date: any, withTime = true) => {
  if (!date) {
    return "N/A";
  }
  const monthMap = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec",
  };
  // case: "2022-01-10T09:18:31Z" /my orders
  const dateVal = new Date(date.includes("T") ? date : date.replace(/-/g, "/"));
  const [, month, day, year, time] = dateVal.toString().split(" ");
  const am = time.slice(0, 2) < "12" ? "AM" : "PM";
  // China
  {
    let month: string | number = dateVal.getMonth() + 1;
    let date2: string | number = dateVal.getDate();
    month = month <= 9 ? "0" + month : month;
    date2 = date2 <= 9 ? "0" + date2 : date2;
    if (withTime)
      return `${dateVal.getFullYear()}-${month}-${date2} ${time} ${am}`;
    return `${dateVal.getFullYear()}-${month}-${date2}`;
  }
  // // Non-China
  // if (withTime) return day + '-' + month + '-' + year + ' ' + time + ' ' + am
  // return day + '-' + month + '-' + year
};
export function invokeZCBot(config: any, router?: any) {
  let {
    invoiceNumber,
    tel,
    company,
    email,
    firstName,
    lastName,
    location,
    contactPhoneNumber,
    requestId,
    caseDescription,
    caseID,
    orderNumber,
    orderDetail,
    orderStatus,
    skuNumber,
    skuProductName,
    promotion_id,
    promotion_title,
    promoData,
    productDetail,
  } = config.payload;
  let base: any = {
    partnerid: email,
    uname: lastName + firstName,
    params: JSON.stringify({}),
    color: "d01013",
  };
  let params: any = {
    ...(company && { Login公司: company }),
    ...(lastName + firstName && { Login姓名: lastName + firstName }),
    ...(tel && { Login电话: removeAreaCode(tel + "") }),
    ...(email && { Login邮箱: email }),
  };

  if (orderNumber) {
    params = {
      ...params,
      订单状态:
        orderStatusMap[
          (
            orderStatus || orderDetail.orderStatus
          ).toUpperCase() as keyof typeof orderStatusMap
        ],
      订单编号: orderNumber,
      // 下单时间: new Date((orderDetail.orderDate)).getTime()
      // goods_count: orderDetail.itemCount || orderDetail?.skuList?.length || undefined,
      // total_fee: Number((orderDetail.formattedOrderTotal || '').replace(/,/g, '') || orderDetail.totalPrice) * 100,
      // goods,
    };
    let order_url = process.env.NEXT_PUBLIC_APPLICATION_ENDPOINT;
    // let goods = JSON.stringify([])
    if (orderDetail.orderLines) {
      order_url += "/my-orders/" + orderNumber;
      // goods = JSON.stringify((orderDetail.orderLines || []).map(item => ({ name: escapeToHtmlEntities(item.product.description), pictureUrl: encodeURIComponent(item.product.image.path + '-150.jpg') })))
    } else if (orderDetail.skuList) {
      order_url += "/my-orders/PendingLTO/" + orderNumber;
      // goods = JSON.stringify((orderDetail.skuList || []).map(item => ({ name: escapeToHtmlEntities(item.productName), pictureUrl: encodeURIComponent(noImageURL) })))
    } else {
      order_url += "/my-orders/" + orderNumber;
    }
    base = {
      ...base,
      user_label: labelMap["Digital CSR"],
      order_status: 0,
      status_custom:
        orderStatusMap[
          (
            orderStatus || orderDetail.orderStatus
          ).toUpperCase() as keyof typeof orderStatusMap
        ],
      order_code: orderNumber,
      type: 4,
      // goods_count: orderDetail.itemCount || orderDetail?.skuList?.length || undefined,
      // total_fee: Number((orderDetail.formattedOrderTotal || '').replace(/,/g, '') || orderDetail.totalPrice) * 100,
      // goods,
      order_url,
    };
    if (orderDetail.orderDate || orderDetail.createTime) {
      base.create_time = new Date(
        orderDetail.orderDate || orderDetail.createTime
      ).getTime();
      params.下单时间 = dateParser(
        orderDetail.orderDate || orderDetail.createTime
      );
    }
  } else {
    base = {
      ...base,
      user_label: labelMap["Presales"],
    };
  }
  if (contactPhoneNumber) {
    base = {
      ...base,
      type: 4,
      card_title: "咨询编号：" + (requestId || caseID),
      card_note: `咨询电话：${removeAreaCode(contactPhoneNumber + "")}`,
      card_desc: `问题描述：${caseDescription}`,
      card_url:
        process.env.NEXT_PUBLIC_APPLICATION_ENDPOINT +
        "/my-request-china/" +
        (requestId || caseID),
    };
    params = {
      ...params,
      咨询电话: removeAreaCode(contactPhoneNumber + ""),
      咨询编号: requestId || caseID,
      问题描述: caseDescription,
    };
  }
  if (promotion_id) {
    // params = {
    //   ...params,
    //   促销ID: promotion_id,
    //   促销标题: promotion_title
    // }
    base = {
      ...base,
      type: 4,
      card_title: promotion_title,
      card_note: `时间：${
        getFormatedDate2(promoData.startDate) +
        "-" +
        getFormatedDate2(promoData.endDate)
      }`,
      card_desc: `活动描述：${promoData.promotionSubtext}`,
      card_url: `${config.APPLICATION_ENDPOINT}/promotions/${promoData.promoType}/${promoData.pageTitle}/${promoData.promotionId}?from=PromotionsListPage&placeholder=promotion_listpage_promotions`,
      // card_url: process.env.NEXT_PUBLIC_APPLICATION_ENDPOINT + '/my-request-china/' + (requestId || caseID),
    };
  }
  if (skuNumber) {
    skuProductName = removeTags(skuProductName);
    const routeURL =
      process.env.NEXT_PUBLIC_APPLICATION_ENDPOINT +
      `/product-details/${productTitleDecoder(
        skuProductName
      )}/${skuNumber}?placeholderName=${"zhichi-chat"}&productPlacement=${"zhichi-chat"}`;
    params = {
      ...params,
      货号: skuNumber,
      产品名称: removeTags(escapeToHtmlEntities(skuProductName)),
    };
    let productUrl =
      productDetail?.images && productDetail?.images[0]?.path
        ? productDetail.images[0].path + "-150.jpg"
        : productDetail?.imageUrl
        ? productDetail?.imageUrl
        : config.APPLICATION_ENDPOINT + "default-img.jpg";
    try {
      const parsedUrl = new URL(productUrl);
      if (parsedUrl.host.includes("scm-dev.s3.cn-north-1.amazonaws.com.cn")) {
        productUrl = config.APPLICATION_ENDPOINT + "default-img.jpg";
      }
    } catch (err) {
      console.error("Invalid URL:", productUrl);
      productUrl = config.APPLICATION_ENDPOINT + "default-img.jpg";
    }
    base = {
      ...base,
      type: 4,
      card_title: removeTags(escapeToHtmlEntities(skuProductName)),
      card_note: "货号：" + skuNumber,
      card_desc: removeTags(
        escapeToHtmlEntities(
          productDetail.shortDescription ||
            productDetail.productLongDescription?.substring(0, 40) ||
            productDetail.teaserText
        )
      ),
      card_url: routeURL,
      card_picture: productUrl,
    };
  }
  if (invoiceNumber) {
    params.发票编号 = invoiceNumber;
  }
  params.来源渠道 = "Mobility";
  params.发起页URL = location;
  base.params = JSON.stringify(params);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile && router) {
    encrypt(JSON.stringify(base)).then((encryptedData) => {
      sessionStorage.setItem("chatParams", JSON.stringify(encryptedData));
      router({
        pathname: "/zhichi-consult",
      });
    });
  } else {
    // @ts-ignore
    zc("clear_config");
    // @ts-ignore
    zc("config", {
      auto_expand: true,
      custom: true,
      refresh: true,
      channelid: sobotChannelId,
      reload: true,
      re_render: true,
      ...base,
    });
    // @ts-ignore
    zc("frame_status", function (res) {});
  }
}

function removeTags(str: string) {
  if (typeof str !== "string") return str;
  return str
    .replace(/<i>/g, "")
    .replace(/<\/i>/g, "")
    .replace(/<p>/g, "")
    .replace(/<\/p>/g, "");
}
const orderStatusMap = {
  PENDING_REVIEW_NOTE: "若订单审核超过48小时，建议您点击需要帮助",
  "Waiting for Delivery": "等待交货",
  SUBMITTED: "已提交",
  ORDER_SUBMITTED: "订单已提交",
  PENDING_REVIEW: "待审核",
  TO_BE_CONFIRMED: "待确认",
  IN_PROGRESS: "处理中",
  COMPLETED: "已完成",
  PENDING_ADDRESS_VALIDATION: "等待确认地址",
  CANCELLED: "已取消",
  PENDING_APPROVAL: "待批准",
  SHIPPED: "已发货",
  PENDING: "等待中",
};

function escapeToHtmlEntities(text: any) {
  const htmlEntities = {
    "&copy;": "©",
    "&reg;": "®",
    "&trade;": "™",
  };

  const regex = new RegExp(Object.keys(htmlEntities).join("|"), "g");
  return (text || "").replace(
    regex,
    (match: keyof typeof htmlEntities) => htmlEntities[match]
  );
}

function removeAreaCode(phoneNumber: any) {
  const regex = /^(\+?|0)?(86)?\s*(\d{1,11})$/;
  const match = phoneNumber.match(regex);
  if (match) {
    return match[3];
  } else {
    return phoneNumber;
  }
}
export const getFormatedDate2 = (time: any) => {
  let date = new Date(time);
  let month = date.getMonth() + 1;
  let twoDigitMonth = ("00" + month.toString()).slice(-2);
  let day = date.getDate();
  let twoDigitDay = ("00" + day.toString()).slice(-2);
  let year = date.getFullYear();
  return year + "/" + twoDigitMonth + "/" + twoDigitDay;
};
export function productTitleDecoder(title: string) {
  let decodedUrlTitle = "title";
  try {
    decodedUrlTitle = title.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "");
  } catch (err: any) {
    return decodedUrlTitle;
  }
  return decodedUrlTitle;
}

export function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
export const getAuthToken = () => {
  return  sessionStorage.getItem(SESSION_STORAGE_KEY_MAP.AUTH_TOKEN) || cookie.get("token") || ''
};
export const formatPrice = (price: string | number | undefined) => {
  // check if is number
  // let price = 'N/A'
  if (!price) return "";
  if (isNaN(Number(price))) {
    return price;
  } else {
    // formatted price as 1,000.00
    const fed = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "¥ " + fed;
    //return Number(price).toLocaleString('en-US', { style: 'currency', currency: '¥' })
  }
};

export const formatDate = (date: string) => {
  // format date as 2022年1月10日
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return `${year}年${month}月${day}日`;
};
export const handleLogin = () => {
  console.log("loginUrl", getLoginURL("campaigns"));
  const loginUrl = getLoginURL("campaigns");
  console.log("loginUrl", loginUrl);
  logOperation({
    opUser: getAAId(),
    opTarget: "login",
    opTargetId: "",
    opContent: "login",
  });
  window.location.href = getLoginURL("campaigns");
};

export function getRegisterURL() {
  let location = "";
  if (window.location.host === "localhost:3000") {
    location = config.APPLICATION_ENDPOINT;
  } else {
    location = `https://${window.location.host}`;
  }
  const backPath = encodeURIComponent(window.location.pathname + window.location.search);
  const search = window.location.search;
  search && localStorage.setItem("registerSearch", search);
  console.log("search", search);
  const redirectURI = isWechatMiniProgramEnv() ? config.ssoCallbackUrl : `${location}/onboarding?cid=${config.CID_REGISTER_CN}registration=more`;
  return `${
    config.NEW_REGISTER_API_ENDPOINT
  }?response_type=code&client_id=${
    getCurrentLoginClientId()
  }&redirect_uri=${redirectURI}&scope=openid%20profile%20email%20username&state=${backPath}`;
}

export const handleRegister = () => {
  logOperation({
    opUser: getAAId(),
    opTarget: "register",
    opTargetId: "",
    opContent: "register",
  });
  window.location.href = getRegisterURL();
};

export const isValidEmail = (email: string) => {
  if (!email) return false;
  const regex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
  return regex.test(email);
};
export const gotoPromotions = (loginState?: any) => {
  loginState &&
    logOperation({
      opUser: loginState?.user?.user?.userId || getAAId(),
      opTarget: "All_Campaigns",
      opTargetId: "",
      opContent: "All_Campaigns",
    });
  if (isMobile()) {
    window.location.href = `${config.APPLICATION_ENDPOINT}/promotions`;
  } else {
    let toUrl = "https://www.thermofisher.cn/cn/zh/home/promo/diversity-campaigns.html";
    window.open(toUrl, "_blank");
  }
};
export const gotoHeaderPromotions = (loginState?: any) => {
  loginState &&
    logOperation({
      opUser: loginState?.user?.user?.userId || getAAId(),
      opTarget: "All_Campaigns",
      opTargetId: "",
      opContent: "All_Campaigns",
    });
  if (isMobile()) {
    window.location.href = `${config.APPLICATION_ENDPOINT}/promotions`;
  } else {
    let toUrl =
      "https://www.thermofisher.cn/cn/zh/home/promo/diversity-campaigns.html";
    window.open(toUrl, "_blank");
  }
};
export function debounce(fn: Function, delay = 1000) {
  let timer: any = null;
  return (...args: any) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      console.log("args", args);
      fn(...args);
    }, delay);
  };
}

let AAId = "";
export const getAAId = () => {
  if (AAId) {
    return AAId;
  }
  const aaId = cookie.get(
    decodeURIComponent("AMCV_5B135A0C5370E6B40A490D44%40AdobeOrg")
  );
  if (aaId) {
    const match = aaId.match(/(\|MCMID\|)(\d+\|)/);
    if (match && match[2]) {
      console.log("match", match[2]);
      const res = match[2]?.replace(/'/g, "");
      console.log("aaid", res);
      AAId = res;
      return res;
    }
    return "";
  }
  return "";
};

export const getProductCount = (products: any) => {
  let productCount = 0;
  products?.map((productItem: any) => {
    if (productItem.checked) {
      productCount += productItem.quantity;
    }
  });

  return productCount;
};

export const getSkuCount = (cartData: any) => {
  let products: any[] = [];
  let activityProducts: any[] = [];
  let exchangeProducts: any[] = [];

  cartData?.activity?.productGroup?.map((group: any) => {
    if (group?.cartItems?.length > 0) {
      activityProducts = [...activityProducts, ...group.cartItems];
    }
  });
  cartData?.exchange?.productGroup?.map((group: any) => {
    if (group?.cartItems?.length > 0) {
      exchangeProducts = [...exchangeProducts, ...group.cartItems];
    }
  });

  products = [...activityProducts, ...exchangeProducts];

  return getProductCount(products);
};
